import type { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker'

import { bothSchemes } from '../utils'

/**
 * Календарь в шите «Дата рождения». Показываем его только inline, поэтому
 * панель без рамки и без тени — фоном служит сам шит.
 *
 * Ячейка дня 40×40 с радиусом плашки: сетка 7×6 ровно ложится в ширину
 * контента шита (358px минус отступы), как и остальные списки в профиле.
 */
export const datePickerConfig = (): DatePickerDesignTokens => ({
  panel: {
    borderRadius: 'var(--radius-xl)',
    padding: '0',
    shadow: 'none',
  },
  header: {
    padding: '0 0 var(--space-4)',
  },
  title: {
    gap: 'var(--space-4)',
    fontWeight: 'var(--fw-bold)',
  },
  selectMonth: {
    padding: 'var(--space-3) var(--space-5)',
    borderRadius: 'var(--radius-m)',
  },
  selectYear: {
    padding: 'var(--space-3) var(--space-5)',
    borderRadius: 'var(--radius-m)',
  },
  dayView: {
    margin: '0',
  },
  weekDay: {
    padding: 'var(--space-3)',
    fontWeight: 'var(--fw-medium)',
  },
  date: {
    width: '40px',
    height: '40px',
    padding: '0',
    borderRadius: 'var(--radius-m)',
  },
  monthView: {
    margin: 'var(--space-4) 0 0',
  },
  month: {
    padding: 'var(--space-6) var(--space-4)',
    borderRadius: 'var(--radius-m)',
  },
  yearView: {
    margin: 'var(--space-4) 0 0',
  },
  year: {
    padding: 'var(--space-6) var(--space-4)',
    borderRadius: 'var(--radius-m)',
  },
  colorScheme: bothSchemes({
    panel: {
      background: 'transparent',
      borderColor: 'transparent',
      color: 'var(--text-color)',
    },
    header: {
      background: 'transparent',
      borderColor: 'transparent',
      color: 'var(--text-color)',
    },
    selectMonth: {
      color: 'var(--text-color)',
      hoverBackground: 'var(--surface-muted)',
      hoverColor: 'var(--text-color)',
    },
    selectYear: {
      color: 'var(--text-color)',
      hoverBackground: 'var(--surface-muted)',
      hoverColor: 'var(--text-color)',
    },
    weekDay: {
      color: 'var(--text-color-secondary)',
    },
    date: {
      color: 'var(--text-color)',
      hoverBackground: 'var(--surface-muted)',
      hoverColor: 'var(--text-color)',
      selectedBackground: 'var(--accent-500)',
      /* На жёлтом читается только тёмный текст — тот же приём, что у галочки */
      selectedColor: 'var(--accent-surface-color)',
    },
    /* Сегодняшний день не выделяем: в шите важна выбранная дата, а не текущая */
    today: {
      background: 'transparent',
      color: 'var(--text-color)',
    },
  }),
})
